import React from 'react';
import { XIcon as CloseRoundedIcon, InfoIcon as InfoOutlinedIcon } from '@phosphor-icons/react';

const defaultContent = ' The sample image on the left is for reference. While changes below will not update it, they will apply to your presentation.';
interface BannerProps {
  open: boolean;
  onClose?: () => void;
  content?: string;
}
export default function Banner({
  open,
  onClose,
  content = defaultContent,
}: BannerProps) {
  if (!open) return null;
  return (
    <div className='flex items-start gap-3 bg-blue-50 mt-6 rounded-md border border-blue-500 dark:bg-transparent p-4'>
      <InfoOutlinedIcon className='text-blue-500' size={20} />
      <p className='text-sm'>
        {content}
      </p>

      {onClose &&
        <CloseRoundedIcon className='cursor-pointer' onClick={onClose} size={20} />
      }
    </div>
  );
}
